import { lazy } from 'react';
import type { ProjetoView } from 'modules/projetos/components/ProjetoViewSwitcher';

/**
 * O código de cada visão do projeto. A rota carrega com ele, e a casca o dispara ao montar, junto com os
 * dados, para o pacote da visão aberta não esperar o projeto chegar. O módulo carrega uma vez só.
 */
export const importarVisao = {
  lista: () => import('./ProjetoDetailPage'),
  kanban: () => import('./ProjetoKanbanPage'),
  gantt: () => import('./ProjetoGanttPage'),
  calendar: () => import('./ProjetoCalendarPage')
} satisfies Record<ProjetoView, () => Promise<unknown>>;

/**
 * Baixa o código das quatro visões quando o navegador fica ocioso: depois disso, trocar de visão não espera
 * o pacote da nova. Devolve a função que cancela, se ainda não começou.
 */
export function baixarVisoesQuandoOcioso(): () => void {
  const baixar = () => Object.values(importarVisao).forEach((importar) => importar().catch(() => {}));
  // Sem requestIdleCallback (Safari), um pouco depois da carga.
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(baixar, { timeout: 5000 });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(baixar, 2000);
  return () => window.clearTimeout(id);
}

// Sem o Loadable: o Suspense fica na casca, em volta do Outlet, com o esqueleto da visão.
export const VisaoLista = lazy(importarVisao.lista);
export const VisaoKanban = lazy(importarVisao.kanban);
export const VisaoGantt = lazy(importarVisao.gantt);
export const VisaoCalendario = lazy(importarVisao.calendar);
